import UploadImageField from './UploadImageField'

export default UploadImageField
